import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useInspectionSrPrefillSyncEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.InspectionSrPrefillSync, false);

  return Boolean(isEnabled);
}
